"use client";

import { PageHeader } from "@/components/general/PageHeader";

function ErrorPage() {
  return (
    <main className="site-main" id="main">
      <div>
        <PageHeader
          heading="500: En feil har oppstått"
          lead="Noe gikk skeis i datamaskinen. Lykke til videre."
        />
      </div>
    </main>
  );
}

export default ErrorPage;
